<template>
  <div class="radius_input_content">
    <input v-model="search" class="radius_input"  @keyup.enter="searchClick" :placeholder="searchVal" type="text">
    <i class="pointer el-icon-search" @click="searchClick"></i>
  </div>
</template>

<script>
  export default {
    name: "radius-input",
    watch: {
      // search(val) {
      //   if (this.markedwords) {
      //     return false
      //   }
      //   this.$emit('searchClick', this.search)
      // }
    },
    props: {
      markedwords: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        search: '',
        searchVal: '请输入关键字'
      }
    },
    methods: {
      searchClick(){
        this.$emit('searchClick', this.search)
      }
    },
    created() {
      if(this.markedwords) {
        this.searchVal = this.markedwords
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .radius_input_content
    width: 90%
    margin: 0px auto
    margin-top: 0
    position: relative

  .pointer
    cursor: pointer
    position: absolute
    right: 20px
    top: 4px
    z-index: 10
    font-size: 16px;

  .radius_input
    position: absolute
    min-width: 200px
    width: 100%
    background: #f2f2f2
    height: 26px
    line-height: 26px
    text-indent: 14px
    border-radius: 20px
    outline: none

</style>



// WEBPACK FOOTER //
// radiusInput.vue?41ca9e68